import applyRoutes from './routes';
import applyViews from './views';
import Captcha from 'volto-form-block/components/Widget/Captcha';
import { reducers } from './reducers';
import {
  installExtraPlugins,
  installStyledSlate,
  overrideIcons,
  removeUnneededSlate,
} from './editor/plugins';
import applyBlocks from './blocks';
// import VoltoTagManager from './components/VoltoTagManager/VoltoTagManager';

const applyConfig = (config) => {
  config.widgets.widget.captcha = Captcha;
  config.settings = {
    ...config.settings,
    isMultilingual: true,
    supportedLanguages: ['en', 'es', 'eu'],
    defaultLanguage: 'en',
    useEmailAsLogin: true,
    showSelfRegistration: true,
    cookiebotDomainGroupId: '5cd00d89-1b05-4c26-8ff7-d02c48bd5ecc',
  };
  config.settings.siteTitleFormat.includeSiteTitle = true;
  config.addonReducers = {
    ...config.addonReducers,
    ...reducers,
  };
  config.blocks.requiredBlocks = [];
  applyRoutes(config);
  applyViews(config);
  applyBlocks(config);
  config = removeUnneededSlate(config);
  config = installStyledSlate(config);
  installExtraPlugins(config);
  config = overrideIcons(config);

  return config;
};

export default applyConfig;
